import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useAddFolderModal } from './context/AddFolderModalContext';
import AddFolderModalHeader from './components/AddFolderModalHeader';
import AddFolderModalBody from './components/AddFolderModalBody';
import AddFolderModalFooter from './components/AddFolderModalFooter';

import './AddFolderModal.scss';

const AddFolderModal: FC = () => {
  const { data } = useAddFolderModal();
  return (
    <>
      <AddFolderModalHeader />
      <AddFolderModalBody />
      <AddFolderModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddFolderModal;
